import "./styles.scss";

import { useSelector } from "react-redux";

import { AppContainer, ResultDetail } from "../../components";

import { useResults } from "../../../hooks/useResults";
import { useEffect, useState } from "react";

import clsx from "clsx";

import { IoCheckmarkCircle } from "react-icons/io5";
import { IoCloseCircleSharp } from "react-icons/io5";
import { HiOutlineRefresh } from "react-icons/hi";


export const Results = () => {
  const { getResults } = useResults();

  const results = useSelector((state) => state.results);

  const [showDetail, setShowDetail] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    getResults();
  }, []);

  const getList = () => {
    if (results && results.length > 0) {
      const usersObject = results.map((user) => ({
        name: user.name,
        total: user.total,
        matches: user.matches,
        status: user.status,
      }));

      const sorterArray = usersObject.sort((a, b) => b.total - a.total);

      return sorterArray.map((user, index) => (
        <div
          key={index}
          className={clsx("w-[85%] flex flex-row items-center justify-between border-l-[1px] border-r-[1px] border-b-[1px] border-white py-[4px] px-4", {
            "border-t-[1px] border-white": index === 0,
          })}
          onClick={() => {
            if (user.status === "PLAYING") {
              setSelectedUser(user);
              setShowDetail(true);
            }
          }}>
          <section className="flex flex-row items-center">
            <span className="text-[14px] w-[26px]">
              {index + 1}.
            </span>
            <span
              className={clsx("text-[14px] ml-1", {
                "opacity-50":
                  user.status === "GAME_OVER" || user.status === "WAITING_START",
              })}>
              {user.name}
            </span>
          </section>

          {
            user.status === "WAITING_START" ? (
              <section className='mr-5'>
                {user.matches ? (
                  <IoCheckmarkCircle className='text-green-400 h-4 w-4' />
                ) : (
                  <IoCloseCircleSharp className='text-[#EF4444] h-4 w-4' />
                )}
              </section>
            ) : (
              <span
                className={clsx("text-[16px] font-bold text-white", {
                  "opacity-50": user.status === "GAME_OVER",
                })}>
                {user.total}
              </span>
            )
          }
        </div >
      ));
    }
  };

  return (
    <>
      {showDetail && (
        <ResultDetail
          data={selectedUser}
          onClose={() => {
            setSelectedUser(null);
            setShowDetail(false);
          }}
        />
      )}
      <AppContainer>
        <div className='flex flex-col items-center w-[100%] z-10'>
          <p className='text-center text-2xl text-white font-bold mt-5'>
            Resultados
          </p>
          <span className="text-xs mt-2">
            Participantes: {results.length}
          </span>

          <button className='text-white/70 flex items-center bg-[rgb(23,43,69,0.5)] border-[1px] border-white/40 rounded-md  py-[6px] px-3 text-[10px] mt-5' onClick={getResults}>
            Actualizar resultados
            <HiOutlineRefresh className='h-4 w-4 ml-3' />
          </button>
          {results && Boolean(results.length) && (
            <div className='h-[85%] max-h-[75dvh] overflow-auto w-[100%] flex flex-col items-center mt-6'>
              {getList()}
            </div>
          )}
        </div>
      </AppContainer>
    </>
  );
};
